import { PolygonMarkerSegmentMidpointHandle } from './PolygonMarkerHandle'
import { calculateMidpoint, drawSegment, drawDashedSegment } from '../../helperFunctions'
import p5 from 'p5'
import type { Point } from '../../types'

interface RenderEdgeOptions {
  isDashed: boolean
  dashLength: number
  dashSpaceLength: number
}

class PolygonMarkerEdge {
  _start: Point
  _end: Point
  midpoint: Point
  midpointHandle: PolygonMarkerSegmentMidpointHandle
  isHovered: boolean

  constructor(start: Point, end: Point) {
    this._start = start
    this._end = end
    this.isHovered = false
    this.midpointHandle = null
    this.updateMidpoint()
  }

  updateMidpoint() {
    this.midpoint = calculateMidpoint(this.start.x, this.start.y, this.end.x, this.end.y)
  }

  updateMidpointHandle() {
    if (this.midpointHandle)
      this.midpointHandle.position = {
        x: this.midpoint.x,
        y: this.midpoint.y,
      }
  }

  update() {
    this.updateMidpoint()
    this.updateMidpointHandle()
  }

  move(deltaX: number, deltaY: number) {
    this.moveStart(deltaX, deltaY)
    this.moveEnd(deltaX, deltaY)
  }

  moveStart(deltaX: number, deltaY: number) {
    const newStartPoint = {
      x: (this.start.x += deltaX),
      y: (this.start.y += deltaY),
    }
    this.start = newStartPoint
  }

  moveEnd(deltaX: number, deltaY: number) {
    const newEndPoint = {
      x: (this.end.x += deltaX),
      y: (this.end.y += deltaY),
    }
    this.end = newEndPoint
  }

  render(
    gfx: p5,
    options: RenderEdgeOptions = {
      isDashed: false,
      dashLength: 5,
      dashSpaceLength: 5,
    }
  ) {
    if (options.isDashed) {
      drawDashedSegment(gfx, { start: this.start, end: this.end }, options.dashLength, options.dashSpaceLength)
    } else {
      drawSegment(gfx, { start: this.start, end: this.end })
    }
  }

  get start(): Point {
    return this._start
  }

  set start(point: Point) {
    this._start = point
    this.update()
  }

  get end(): Point {
    return this._end
  }

  set end(point: Point) {
    this._end = point
    this.update()
  }
}

export { PolygonMarkerEdge }
